function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2821 9V11.5H17.3333C16.7179 15 13.8462 17.5 10.2564 17.5C6.05128 17.5 2.5641 14.1 2.5641 10C2.5641 5.9 6.05128 2.5 10.2564 2.5C12.4103 2.5 14.2564 3.4 15.5897 4.8L17.4359 3C15.5897 1.2 13.1282 0 10.2564 0C4.61538 0 0 4.5 0 10C0 15.5 4.61538 20 10.2564 20C15.8974 20 20 15.5 20 10V9H11.2821Z",
  fill: "#616161"
});

var SvgGooglePlus = function SvgGooglePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_plus.a4c5aa5b.svg";
export { ForwardRef as ReactComponent };